import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
  },
  tableRoot: {
    display: 'flex',
    flexDirection: 'column',
    width: '78%',
    marginTop: '31vh',
    marginLeft: '19%',
    overflowX: 'hidden',
    height: '57vh !important',
    position: 'relative',
  },
  paper: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '80%',
    backgroundColor: '#FFF',
    marginBottom: '3%',
    color: '#949494',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    color: '#949494',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
  },
  iconButton: {
    color: '#949494',
  },
  button: {
    width: '152px',
    backgroundColor: '#026894',
    color: '#FFF',
    paddingTop: '5px',
    paddingBottom: '5px',
    paddingRight: '2px',
    paddingLeft: '2px',
    boxShadow: 'none',
    position: 'relative',
    border: 'none',
    textTransform: 'capitalize',
    fontSize: '12px',
    borderRadius: '6px',
    textAlign: 'center',
    textDecoration: 'none',
    marginLeft: '25px',
    lineHeight: 1.75,
    '&:hover': {
      backgroundColor: '#026894',
    },
  },
  buttonVisualize: {
    width: '100px',
    color: '#FFF',
    paddingTop: '5px',
    paddingBottom: '5px',
    boxShadow: 'none',
    border: 'none',
    textTransform: 'capitalize',
    marginRight: '16px',
  },
  buttonEdit: {
    width: '100px',
    color: '#FFF',
    paddingTop: '5px',
    paddingBottom: '5px',
    boxShadow: 'none',
    border: 'none',
    textTransform: 'capitalize',
    marginRight: '2%',
  },
  buttonDelete: {
    width: '79px',
    backgroundColor: '#FF5756',
    color: '#FFF',
    paddingTop: '5px',
    paddingBottom: '5px',
    boxShadow: 'none',
    border: 'none',
    textTransform: 'capitalize',
    fontSize: '12px',
    marginRight: '2%',
    '&:hover': {
      background: '#a53030',
    },
  },
  link: {
    color: '#FFF',
    textTransform: 'capitalize',
    fontSize: '12px',
    textDecoration: 'none',
  },
  smallLink: {
    color: '#FFF',
    textTransform: 'capitalize',
    fontSize: '12px',
    textDecoration: 'none',
  },
  divSearch: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  table: {
    width: '100%',
  },
  selectStatus: {
    width: '100%',
    border: '1px solid #ccc',
    padding: '7px 6px',
    marginTop: '10px',
  },
  summary: {
    backgroundColor: '#C4C4C4',
    borderRadius: '5px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  details: {
    backgroundColor: '#ECECEC',
    width: '100%',
    padding: '0 !important',
    flexDirection: 'column',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '10px',
    marginBottom: '19px',
  },
  headFilter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonClose: {
    background: 'none',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
  },
  filtersBox: {
    position: 'absolute',
    marginTop: '172px',
    background: '#185b86',
    width: '315px',
    color: '#fff',
    padding: '10px',
    zIndex: '99',
    right: '0',
    marginRight: '9px',
    borderRadius: '5px',
  },
  labelFilter: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  buttonFilter: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    width: '100%',
    padding: '8px 0',
    marginTop: '9px',
    borderRadius: '2px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
}));

export default useStyles;
